export default __webpack_public_path__ + "static/g1three-6c052bab1c854cae487d34d7c4e5430f.jpg";